import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { SmallLoader } from 'framework/ui/mui-builder';
import { useFieldHelper, FieldProps } from 'framework/ui/field';
import DownloadFileLinkField from './DownloadFileLinkField/DownloadFileLinkField';
import { DocumentStorageItemType, useDocumentStorageContext } from 'framework/documentStorage';

type DocumentStorageLoadListFieldProps = FieldProps & {
  value?: Nullable<string[]>;
  permission?: string | string[];
  label?: string;
};

const DocumentStorageLoadListField: React.FC<DocumentStorageLoadListFieldProps> = ({
  label,
  source,
  value,
  permission,
}) => {
  const [documentsData, setDocuments] = useState<DocumentStorageItemType[]>([]);
  const [loading, setLoading] = useState(false);

  const { getValue } = useFieldHelper<string[]>({ source, value });
  const { getDocumentByPaths } = useDocumentStorageContext();

  const paths = getValue() || [];

  const getFiles = async (filesPath: string[]) => {
    if (!filesPath.length) {
      setDocuments([]);
      return;
    }

    setLoading(true);

    try {
      const files = await getDocumentByPaths(Array.isArray(filesPath) ? filesPath : [filesPath]);
      setDocuments(files);
    } catch (err) {
      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFiles(paths);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paths]);

  if (loading) {
    return <SmallLoader />;
  }

  if (!documentsData.length) {
    return null;
  }

  return (
    <Box display="flex" alignItems="flex-start" flexDirection="column">
      <Typography variant="body2">{label || 'Attachments:'}</Typography>
      {documentsData.map(fileData => (
        <DownloadFileLinkField
          key={fileData.id}
          metadataSource=""
          pathSource=""
          metadataValue={fileData.metadata}
          pathValue={fileData.path}
          permission={permission}
        />
      ))}
    </Box>
  );
};

export default DocumentStorageLoadListField;
